import React from 'react';
import { IconButton } from '@material-ui/core';
import { ContentCopy } from '../../assets/img/ContentCopy';
import { useClipboard } from '../../hooks/useClipboard';

export const CopyKeyButton: React.FC<{ licenseKey?: string }> = ({ licenseKey }) => {
  const { copyText } = useClipboard({
    successMessage: 'Enscape License Key has been copied to the clipboard.',
  });

  return !licenseKey ? null : (
    <IconButton size='small' onClick={() => void copyText(licenseKey)}>
      <ContentCopy />
    </IconButton>
  );
};
